import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, completedSteps, estimatedTime }) => {
  const progressPercentage = (completedSteps / totalSteps) * 100;

  const steps = [
    { id: 1, title: 'Skills Inventory', description: 'Rate your technical and soft skills' },
    { id: 2, title: 'Career Goals', description: 'Define and prioritize your objectives' },
    { id: 3, title: 'Work Experience', description: 'Share your professional journey' },
    { id: 4, title: 'Preferences', description: 'Work environment and role preferences' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-text-primary">Assessment Progress</h2>
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="Clock" size={16} />
          <span>{estimatedTime} min remaining</span>
        </div>
      </div>
      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-text-primary">
            Step {currentStep} of {totalSteps}
          </span>
          <span className="text-sm text-text-secondary">
            {Math.round(progressPercentage)}% Complete
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full spring-transition"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
      {/* Step Indicators */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {steps?.map((step) => (
          <div
            key={step?.id}
            className={`flex items-start space-x-3 p-3 rounded-md spring-transition ${
              step?.id === currentStep
                ? 'bg-primary/10 border border-primary/20'
                : step?.id < currentStep
                ? 'bg-success/10 border border-success/20' :'bg-muted border border-border'
            }`}
          >
            <div
              className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${
                step?.id === currentStep
                  ? 'bg-primary text-primary-foreground'
                  : step?.id < currentStep
                  ? 'bg-success text-success-foreground'
                  : 'bg-muted-foreground text-background'
              }`}
            >
              {step?.id < currentStep ? (
                <Icon name="Check" size={12} />
              ) : (
                step?.id
              )}
            </div>
            <div className="min-w-0 flex-1">
              <p className={`text-sm font-medium ${
                step?.id <= currentStep ? 'text-text-primary' : 'text-text-secondary'
              }`}>
                {step?.title}
              </p>
              <p className="text-xs text-text-secondary mt-1">
                {step?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;